import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext.jsx';

function KioskNavBar() {
  const { user, logout } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname.startsWith(path);

  const isManagerOrCS = ['customer_service', 'manager'].includes(user?.role);
  const isManager = user?.role === 'manager';

  const handleLogout = async () => {
    try { await logout(); } catch { /* ignore */ }
    localStorage.removeItem('kioskAuthToken');
    localStorage.removeItem('kioskUser');
    window.location.href = '/kiosk/login';
  };

  const linkStyle = (active) => ({
    padding: '0.375rem 0.75rem',
    borderRadius: '0.5rem',
    fontWeight: '500',
    fontSize: '12px',
    textDecoration: 'none',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    backgroundColor: active ? 'rgba(99,102,241,0.5)' : 'transparent',
    color: '#ffffff',
    border: active ? '1px solid rgba(165,180,252,0.6)' : '1px solid transparent',
    whiteSpace: 'nowrap',
    transition: 'all 0.2s ease',
  });

  const getDisplayName = () => {
    if (user?.firstName) return user.firstName;
    const u = user?.username || '';
    return (u.includes('.') ? u.split('.')[0] : u).replace(/^./, c => c.toUpperCase()) || 'Staff';
  };

  return (
    <header
      style={{
        padding: '0.75rem',
        borderRadius: '0.75rem',
        marginBottom: '1rem',
        background: 'rgba(30, 27, 75, 0.85)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(99,102,241,0.4)',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '0.5rem',
        fontFamily: 'Inter, system-ui, sans-serif',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      }}
    >
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
        <Link to="/kiosk/pos/salon" style={linkStyle(isActive('/kiosk/pos'))}>POS</Link>
        <Link to="/kiosk/inventory" style={linkStyle(isActive('/kiosk/inventory'))}>Inventory</Link>
        {(isManagerOrCS || user?.role === 'admin') && (
          <Link to="/kiosk/comms-marketing" style={linkStyle(isActive('/kiosk/comms-marketing'))}>Comms</Link>
        )}
        {(isManagerOrCS || user?.role === 'admin') && (
          <Link to="/kiosk/signage" style={linkStyle(isActive('/kiosk/signage'))}>Signage</Link>
        )}
        {(isManager || user?.role === 'admin') && (
          <Link to="/kiosk/attendance" style={linkStyle(isActive('/kiosk/attendance'))}>Attendance</Link>
        )}
        {(isManager || user?.role === 'admin') && (
          <Link to="/kiosk/payroll" style={linkStyle(isActive('/kiosk/payroll'))}>Payroll</Link>
        )}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.7)', fontWeight: '500' }}>
          {user?.role === 'manager' ? 'Manager:' : user?.role === 'customer_service' ? 'CS:' : 'Staff:'}{' '}
          <strong style={{ color: '#fff' }}>{getDisplayName()}</strong>
        </span>
        <button
          onClick={handleLogout}
          style={{
            padding: '0.3rem 0.75rem',
            borderRadius: '0.5rem',
            fontSize: '12px',
            fontWeight: '500',
            backgroundColor: 'rgba(239,68,68,0.3)',
            color: '#fff',
            border: '1px solid rgba(239,68,68,0.5)',
            cursor: 'pointer',
          }}
        >
          Logout
        </button>
      </div>
    </header>
  );
}

export default KioskNavBar;
